// extracted by mini-css-extract-plugin
export default {"root":"ContentLayout-module--root--aeff4","titleRow":"ContentLayout-module--titleRow--840a5","type":"ContentLayout-module--type--badcb"};